import React from 'react';
import styled from 'styled-components/macro';
import Cog from '@material-ui/icons/Settings';
import SaveSuccess from '@material-ui/icons/CloudDone';
import SaveFailed from '@material-ui/icons/CloudOff';
import Colors from '../../internal-components/Colors';
import Button from '../Button';

export const IconsCSS = `
.cog {
  transition: 0.3s;
  opacity: 0;
  transform-origin: center;
  transform: scale(0);
  width: 0;
  animation: rotation 2s infinite linear;
}

.cloud {
  transition: 0.3s;
  opacity: 0;
  transform-origin: center;
  transform: scale(0);
  width: 0;
}

.failed-cloud {
  transition: 0.3s;
  opacity: 0;
  transform-origin: center;
  transform: scale(0);
  width: 0;

}

&.saving .cog {
  opacity: 1;
  width: 1em;
  transform: scale(1);
}

&.saved .cloud {
  opacity: 1;
  width: 1em;
  transform: scale(1);
}

&.failed .failed-cloud {
  opacity: 1;
  width: 1em;
  transform: scale(1);
}
@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
`;

const SaveElement = styled.div`
  margin-right: auto;
  display: flex;
  align-items: center;
  color: ${Colors.DARK_GREY};
  opacity: 0.6;

  ${IconsCSS}

  &.failed::after {
    content: 'Changes not saved.';
    margin: 0 0.8em;
  }

  &.saving::after {
    content: 'Saving...';
    margin: 0 0.8em;
  }

  &.saved::after {
    content: 'Saved.';
    margin: 0 0.8em;
  }
`;

const SCButton = styled(Button)`
  && {
    ${({ $customCSS }) => $customCSS}
  }

  ${IconsCSS}

  svg {
    font-size: 20px;
  }
`;

export const States = {
  SAVING: 'saving',
  SAVED: 'saved',
  FAILED: 'failed'
};

/**
 *
 * @param {States} state - state to set the component to (options are from States map)
 * @param {*} targets - String/ Element/ Array of elements - used to locate the SaveChanges component and appens the style onto it
 */
export const setState = (state, targets) => {
  if (!Object.values(States).includes(state)) {
    return;
  }

  if (typeof targets === 'string') {
    targets = Array.from(document.querySelectorAll(targets));
  }

  targets = [].concat(targets); // if we didn't get an array

  targets.forEach(sc => {
    Object.values(States).forEach(className => {
      sc.classList.remove(className);
      sc.classList.add(state);
    });
  });
};

const SaveChanges = ({ id }) => {
  return (
    <SaveElement data-id={id} data-testid={id}>
      <Cog className="cog" />
      <SaveSuccess className="cloud" />
      <SaveFailed className="failed-cloud" />
    </SaveElement>
  );
};

export const SaveChangesButton = ({
  id,
  customCSS,
  onClick = () => {},
  children,
  ...btnProps
}) => {
  return (
    <SCButton
      onClick={onClick}
      id={id}
      data-id={id}
      data-testid={id}
      // variant="outlined"
      $customCSS={customCSS}
      startIcon={<SCIcon />}
      {...btnProps}
    >
      {children}
    </SCButton>
  );
};

export const SCIcon = () => {
  return (
    <>
      {/* <SaveIcon className="floppy" /> */}
      <Cog className="cog" />
      <SaveSuccess className="cloud" />
      <SaveFailed className="failed-cloud" />{' '}
    </>
  );
};

export default SaveChanges;
